export default __webpack_public_path__ + "static/orchestrate-a5c7cbe4917c06ca8bb32cf1f3932cd0.png";